export default __webpack_public_path__ + "static/Checkerboard-20c06391422016e12f637d2a6169f89e.jpg";